import React, {ReactElement, useEffect, useRef, useState} from 'react';
import INcaseLogo from '../../../../../assets/incase-logo-black.svg';
import {getBorderStyle} from '../../../../utils/style.utils';
import {IElementImageMarkup} from '../../../../incase-domain/elements/question/imageMarkup';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import QuestionLayout from '../common/QuestionLayout';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';
import ImageMarkupModal from '../../../slides/highlighted/ImageMarkupModal';
import CanvasQuestionMarkedAreas from '../../../../ui/components/CanvasQuestionMarkedAreas';

function ImageMarkupQuestionElement(props: IQuestionElementProps<IElementImageMarkup>): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;
    const {imageSrc, title, markedAreas, borderRadius} = element;

    const [markImageModalOpen, setMarkImageModalOpen] = useState<boolean>(false);

    const imageRef = useRef<HTMLImageElement | null>(null);

    const [canvasDimensions, setCanvasDimensions] = useState<{
        width: number;
        height: number;
    }>({
        width: 0,
        height: 0,
    });

    useEffect(() => {
        if (imageRef.current) {
            setCanvasDimensions({width: imageRef.current.width, height: imageRef.current.height});
        }
    }, [imageRef.current?.width, imageRef.current?.height]);

    return (
        <>
            <QuestionLayout element={element} device={device} showConfirmButton>
                <div className="c-imageMarkup__canvas" onDoubleClick={() => setMarkImageModalOpen(true)}>
                    <img
                        ref={imageRef}
                        src={imageSrc || INcaseLogo}
                        alt=""
                        title={title}
                        style={{
                            borderRadius: getBorderStyle(borderRadius),
                        }}
                    />
                    <CanvasQuestionMarkedAreas markedAreas={markedAreas} width={canvasDimensions.width} height={canvasDimensions.height} />
                </div>
            </QuestionLayout>

            <ImageMarkupModal
                element={element}
                isOpen={markImageModalOpen && !!element.imageSrc}
                onCancel={() => setMarkImageModalOpen(false)}
            />
        </>
    );
}

export default ImageMarkupQuestionElement;
